import { useQuery } from "@tanstack/react-query";
import homepageApi, { HOMEPAGE_KEY } from "../../api/homepageApi";

export const useGetTextHomepage = () => {
    return useQuery({
        queryKey: HOMEPAGE_KEY,
        queryFn: async () => {
            const res = await homepageApi.getText();
            const data = res.data?.data?.[0] ?? res.data?.[0];
            return data ?? null;
        },
    });
};